module.exports = __webpack_public_path__ + "061c36542becefcefbe410b886234b67.png";